jQuery(document).ready(function () {

  jQuery('#keyword').bind('keypress keyup', function (e) {
    console.log("pressed");
    if (jQuery(this).val().length > 3) {
      fetch();
      jQuery("#datafetch").addClass("active");
    } else {
      jQuery("#datafetch").removeClass("active");
    }
  });

  jQuery(".nhr-form").focusout(function () {
    setTimeout(
      function () {
        jQuery("#datafetch").removeClass("active");
        console.log("aaaaa");
      }, 250);
  });

  if (jQuery(".wpcf7 form.sent .wpcf7-response-output").length) {
    jQuery('html, body').animate({
      scrollTop: jQuery(".wpcf7 form.sent .wpcf7-response-output").offset().top
    }, 500);
  }

});